"use client";
import { jsx as t } from "react/jsx-runtime";
import * as d from "react";
import { cn as o } from "./index15.js";
const s = d.forwardRef(
  ({ className: e, ...a }, r) => /* @__PURE__ */ t(
    "div",
    {
      ref: r,
      className: o("rounded-lg border border-border bg-surface shadow-sm", e),
      ...a
    }
  )
);
s.displayName = "Card";
const i = d.forwardRef(
  ({ className: e, ...a }, r) => /* @__PURE__ */ t("div", { ref: r, className: o("flex flex-col space-y-1.5 p-6", e), ...a })
);
i.displayName = "CardHeader";
const m = d.forwardRef(
  ({ className: e, ...a }, r) => /* @__PURE__ */ t(
    "h3",
    {
      ref: r,
      className: o("font-semibold leading-none tracking-tight text-text", e),
      ...a
    }
  )
);
m.displayName = "CardTitle";
const c = d.forwardRef(({ className: e, ...a }, r) => /* @__PURE__ */ t("p", { ref: r, className: o("text-sm text-text-muted", e), ...a }));
c.displayName = "CardDescription";
const l = d.forwardRef(
  ({ className: e, ...a }, r) => /* @__PURE__ */ t("div", { ref: r, className: o("p-6 pt-0", e), ...a })
);
l.displayName = "CardContent";
const n = d.forwardRef(
  ({ className: e, ...a }, r) => /* @__PURE__ */ t("div", { ref: r, className: o("flex items-center p-6 pt-0", e), ...a })
);
n.displayName = "CardFooter";
export {
  s as Card,
  l as CardContent,
  c as CardDescription,
  n as CardFooter,
  i as CardHeader,
  m as CardTitle
};
//# sourceMappingURL=index7.js.map
